// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wc_a bhn_b bhn_we"};